<template>
  <div>
    <table class="table table-sm table-hover" v-if="Object.keys(collateralReport).length != 0">
      <caption class="table-caption text-left">{{dealName}} Loans</caption>
      <thead>
        <th class="text-left sticky">{{groupByField}}</th>
        <th class="text-right sticky">Original Balance</th>
        <th class="text-right sticky">Current Balance</th>
        <th class="text-right sticky">Delinquency30 Pct</th>
        <th class="text-right sticky">Delinquency60 Pct</th>
        <th class="text-right sticky">Delinquency90Plus Pct</th>
        <th class="text-right sticky">Loans Count</th>
      </thead>
      <tbody>
        <tr v-for="row in collateralReport" :key=row.Date>
          <td class="text-left text-nowrap">{{row.Date}}</td>
          <td class="text-right">{{row.OriginalBalance}}</td>          
          <td class="text-right">{{row.CurrentBalance}}</td>
          <td class="text-right">{{row.Delinquency30}}</td>
          <td class="text-right">{{row.Delinquency60}}</td>
          <td class="text-right">{{row.Delinquency90Plus}}</td>
          <td class="text-right">{{row.LoansCount}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    groupByField: String,
    dealName: String,
    collateralReport: Array
  }
}
</script>

